/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_GInputs */

const en_tut_wakil_g = /** @type {(inputs: Tut_Wakil_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is not an auto-reply. The Digital Deputy reads your handover note and the context it is allowed to read, then answers as needed — only while you are genuinely unavailable.`)
};

const id_tut_wakil_g = /** @type {(inputs: Tut_Wakil_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini bukan auto-reply. Wakil Digital membaca catatan serah terima Anda dan konteks yang boleh dibacanya, lalu menjawab seperlunya — hanya saat Anda memang sedang tidak tersedia.`)
};

/**
* | output |
* | --- |
* | "This is not an auto-reply. The Digital Deputy reads your handover note and the context it is allowed to read, then answers as needed — only while you are gen..." |
*
* @param {Tut_Wakil_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_g = /** @type {((inputs?: Tut_Wakil_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_g(inputs)
	return en_tut_wakil_g(inputs)
});